// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import RegistrationError from '@deere/cps-it.warranty-model-factory/lib/registration-error';

const Errors = ({errors}) => {

    const registrationErrors = errors.map(error => (
        <li key={error.id}>
            {error.description}
        </li>
    ));

    return registrationErrors.length > 0 &&
        <div className='help-text'>
            <ul>
                {registrationErrors}
            </ul>
        </div>;

};

Errors.displayName = 'Errors';
Errors.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.instanceOf(RegistrationError)).isRequired
};

export default Errors;



// WEBPACK FOOTER //
// ./src/product/product-registration/components/product-registration-form/errors.js